import { useSelector } from 'hooks/utils';

export function useEligibleForInviteEmails(): string[] {
	return useSelector(state => state.data.accounts.users.eligibleForInvitation);
}
